import { render, staticRenderFns } from "./DisbursementSchedule.vue?vue&type=template&id=118529bf&"
import script from "./DisbursementSchedule.vue?vue&type=script&lang=ts&"
export * from "./DisbursementSchedule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports